<template>
  <div class="container">
    <!-- 详情 -->
    <div class="detail-content">
      <div class="detail-content-header">
        <p class="fs-20">{{ baseInfo.title }}</p>
        <p class="color-999 mt-20">发布时间：{{ baseInfo.fbstartDate }}</p>
      </div>
      <div class="detail-content-body" v-html="baseInfo.content" />
    </div>
  </div>
</template>

<script>
import { getSEOConfig, setPageSEO } from "@/utils/seoConfig";

export default {
  name: "",
  components: {},
  props: {
    baseInfo: {
      type: Object,
      default: () => ({}),
    },
    tableType: {
      type: String | Number,
      default: "1",
    },
    sectionId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      noticeType: "",
      detailList: [],
      detailInfo: {},
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  // 方法集合
  methods: {
    // 设置seo
    updateSEO() {
      if (this.baseInfo && this.baseInfo.title) {
        const dynamicData = {
          title: this.baseInfo.title || "",
        };

        const seoConfig = getSEOConfig(this.$route.path, dynamicData);
        setPageSEO(seoConfig);
      }
    },
  },
  watch: {
    baseInfo: {
      handler(val) {
        if (val && val.title) {
          this.updateSEO();
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  padding-bottom: 20px;
}
.detail-header {
  border: 1px solid #ddd;
  background-color: #fff;
  .title {
    height: 94px;
    line-height: 94px;
    text-align: center;
    font-size: 26px;
    font-weight: bold;
  }
  .detail-info {
    border-top: 1px solid #ddd;
    padding: 30px 0;
    font-size: 16px;
    .detail-info-item {
      flex: 1;
      width: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      .application-btn {
        width: 90px;
        height: 32px;
        border-radius: 0;
        padding: 0;
        margin-top: 14px;
        &.is-disabled {
          background-color: #ddd;
          border-color: #ddd;
        }
      }
    }
    .detail-info-item + .detail-info-item {
      border-left: 1px solid #ddd;
    }
  }
}
.notice-list {
  height: 100px;
  margin-top: 20px;
  border: 1px solid #ddd;
  padding: 0 37px;
  background-color: #fff;
  .notice-item {
    width: 250px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
    font-size: 20px;
    color: #999;
    cursor: not-allowed;
    img {
      width: 25px;
      height: 25px;
      margin-right: 10px;
    }
  }
  .can-view {
    cursor: pointer;
    color: $--color-primary;
  }
  .active {
    cursor: pointer;
    background: $--color-primary;
    color: #fff;
  }
}
.detail-table {
  margin-top: 20px;
  border: 1px solid #ddd;
  border-bottom: 0;
  &::before {
    height: 0;
  }
  .select-btn {
    width: 70px;
    height: 24px;
    padding: 0;
    text-align: center;
    border-radius: 0;
    &.is-active {
      background-color: $--color-primary;
      color: #fff;
    }
  }
}
.detail-content {
  background-color: #fff;
  padding: 0 20px;
  border: 1px solid #ddd;
  margin-top: 20px;
  .detail-content-header {
    height: 136px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>
